/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');

var SideNavSectionView = require('common/views/SideNavSectionView');
var switchToPrint = require('common/util/switchToPrint');

var MortgageDiscountCompanyAnnualReportViewGeneralDetailsSectionView = require('./MortgageDiscountCompanyAnnualReportGeneralDetailsSectionView');
var MortgageDiscountCompanyAnnualReportFinancialStatementsSectionView = require('./MortgageDiscountCompanyAnnualReportFinancialStatementsSectionView');
var MortgageDiscountCompanyAnnualReportProductionReportSectionView = require('./MortgageDiscountCompanyAnnualReportProductionReportSectionView');
var MortgageDiscountCompanyAnnualReportAffirmationSectionView = require('./MortgageDiscountCompanyAnnualReportAffirmationSectionView');
var SubmitMortgageDiscountCompanyAnnualReport = require('../../services/SubmitMortgageDiscountCompanyAnnualReport');
var tmplMortgageDiscountCompanyAnnualReportView = require('./MortgageDiscountCompanyAnnualReportView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplMortgageDiscountCompanyAnnualReportView,

  className: 'debt-management-services-annual-report-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    mortgageDiscountCompanyAnnualReportContainer: '.mortgage-discount-company-annual-report-container'
  },

  regions: {
    mortgageDiscountCompanyAnnualReportContainer: '@ui.mortgageDiscountCompanyAnnualReportContainer'
  },

  onBeforeShow: function() {
    var mode = this.options.mode;
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'mortgageDiscountCompanyAnnualReportGeneralDetails',
          title: 'General Details',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new MortgageDiscountCompanyAnnualReportViewGeneralDetailsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'mortgageDiscountCompanyAnnualReportFinancialStatements',
          title: 'Financial Statements',
          view: new MortgageDiscountCompanyAnnualReportFinancialStatementsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'mortgageDiscountCompanyAnnualReportProductionReport',
          title: 'Production Report',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new MortgageDiscountCompanyAnnualReportProductionReportSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'mortgageDiscountCompanyAnnualReportAffirmation',
          title: 'Affirmation',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new MortgageDiscountCompanyAnnualReportAffirmationSectionView({
            isReadOnly: this.options.isReadOnly,
            mode: this.options.mode,
            model: this.model
          })
        }
      ]),
      expanded: isForPrinting || isExpandInternal,
      useNavigationButtons: !this.options.isReadOnly,
      contentWidth: 'medium',
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        }
      ]
    });

    if (
      this.options.isReadOnly &&
      !(this.options.mode === 'print' || this.options.mode === 'int' || this.options.mode === 'int-expand')
    ) {
      this.form.collection.remove(this.form.collection.get('mortgageDiscountCompanyAnnualReportAffirmation'));
    }

    this.showChildView('mortgageDiscountCompanyAnnualReportContainer', this.form);
  },

  onClickSave: function(e) {
    e.preventDefault();
    var self = this;
    self.form.validateAll({ type: 'save' }).done(function() {
      var l = Ladda.create(e.currentTarget);
      l.start();
      var rawFormData = self.form.getFormData();
      var formData = {
        applicationId: self.model.get('applicationId'),
        annualReportId: self.model.get('annualReportId'),
        generalDetails: rawFormData.mortgageDiscountCompanyAnnualReportGeneralDetails,
        productionReport: rawFormData.mortgageDiscountCompanyAnnualReportProductionReport,
        financialStatements: rawFormData.mortgageDiscountCompanyAnnualReportFinancialStatements,
        affirmation: rawFormData.mortgageDiscountCompanyAnnualReportAffirmation
      };
      SubmitMortgageDiscountCompanyAnnualReport(formData)
        .done(function() {
          l.stop();
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      switchToPrint(this.$el, '.input-view');
    }
  }
});
